import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function MegaMenu({ products }) {
  return (
    <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 w-[min(1100px,95vw)] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
      <div className="mega-menu bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="flex">
          <div className="w-64 bg-[#f7f7f9] border-r border-gray-100 max-h-[460px] overflow-y-auto mega-scroll py-2">
            {products.map((p, i) => (
              <Link
                key={p.id}
                to={`/products/${p.slug}`}
                className="flex items-center justify-between px-4 py-2.5 text-[13.5px] text-[#0d2240] hover:bg-white hover:text-[#c8102e] transition-colors border-l-4 border-transparent hover:border-[#c8102e]"
              >
                <span className="font-medium">
                  <span className="text-[#c8102e] mr-2 font-bold">{String(i + 1).padStart(2, "0")}</span>
                  {p.name}
                </span>
                <ChevronRight size={14} />
              </Link>
            ))}
          </div>
          <div className="flex-1 p-6 max-h-[460px] overflow-y-auto mega-scroll">
            <div className="grid grid-cols-3 gap-5">
              {products.map((p) => (
                <div key={p.id} className="group/col">
                  <Link
                    to={`/products/${p.slug}`}
                    className="flex items-center gap-2 mb-2 font-heading font-semibold text-[12px] text-[#0d2240] uppercase tracking-wider hover:text-[#c8102e]"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#c8102e]" />
                    {p.name}
                  </Link>
                  <ul className="flex flex-col">
                    {p.subProducts.map((s) => (
                      <li key={s.id}>
                        <Link
                          to={`/products/${p.slug}/${s.slug}`}
                          className="block py-0.5 text-[12px] text-gray-600 hover:text-[#c8102e] hover:translate-x-1 transition-all"
                        >
                          • {s.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="mt-5 pt-4 border-t border-gray-100 flex items-center justify-between">
              <p className="text-[12px] text-gray-500">20 product ranges · 100+ tape variants</p>
              <Link
                to="/products"
                className="text-[12px] font-semibold text-white bg-[#c8102e] hover:bg-[#9a0c24] px-3 py-1.5 rounded-md"
              >
                Browse All Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
